import { createStore } from "redux";

const initialState = {
	RenewalId: null,
	RenewalData: {
		drivers: [],
		cars: [],
		// liability_coverage: null,
		covers_misc_damage: false,
	},
	SignData: { signed_url: "", next_url: "", state_name: "" },
	RenewalDataDefault: {},
	RenewalDataMiddleman: {},
	LoadingMonthly: false,
	LoadingPage: true,
	LoadingCheckout: true,
	LoadingQuote: false,
};

function rootReducer(state, action) {
	switch (action.type) {
		case "SET_INITIAL_QUOTE_DATA":
			return {
				...state,
				RenewalData: {
					...state.RenewalData,
					...action.payload,
				},
				RenewalDataDefault: {
					...state.RenewalData,
					...action.payload,
				},
				LoadingMonthly: false,
				LoadingPage: false,
				LoadingCheckout: false,
			};
		case "SET_QUOTE_DATA":
			return {
				...state,
				RenewalData: {
					...state.RenewalData,
					...action.payload,
				},
				LoadingMonthly: false,
				LoadingPage: false,
			};
		case "SET_SIGN_DATA":
			return {
				...state,
				SignData: action.payload,
				LoadingCheckout: false,
			};
		case "SET_LOADING_CHECKOUT":
			return {
				...state,
				LoadingCheckout: action.payload,
			};
		case "SET_LOADING_MONTHLY":
			return {
				...state,
				LoadingMonthly: action.payload,
			};
		case "SET_LOADING_PAGE":
			return {
				...state,
				LoadingPage: action.payload,
			};
		case "SET_LOADING_QUOTE":
			return {
				...state,
				LoadingQuote: action.payload,
			};
		case "PROPERTY_CHANGE":
			return {
				...state,
				RenewalData: {
					...state.RenewalData,
					covers_misc_damage: action.payload,
				},
			};
		case "LIABILITY_CHANGE":
			return {
				...state,
				RenewalData: {
					...state.RenewalData,
					liability_coverage: action.payload,
				},
			};
		case "ADD_NEW_CARS":
			return {
				...state,
				RenewalData: {
					...state.RenewalData,
					cars: action.payload,
				},
			};
		case "ADD_NEW_DRIVERS":
			return {
				...state,
				RenewalData: {
					...state.RenewalData,
					drivers: action.payload,
				},
			};
		case "SET_RENEWAL_ID":
			return {
				...state,
				RenewalId: action.payload,
			};
		case "SET_DEFAULT_DATA":
			return {
				...state,
				RenewalDataDefault: action.payload,
			};
		case "RESTORE_DEFAULT_STATE":
			return {
				...state,
				RenewalData: state.RenewalDataDefault,
			};
		case "SET_MIDDLEMAN_DATA":
			return {
				...state,
				RenewalDataMiddleman: action.payload,
			};
		case "RESTORE_MIDDLEMAN_STATE":
			return {
				...state,
				RenewalData: state.RenewalDataMiddleman,
			};
		default:
			return state;
	}
}

export default function configureStore() {
	const store = createStore(
		rootReducer,
		initialState,
		window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
	);

	return store;
}
